"use client";

import { useRef, useLayoutEffect } from "react";
import {
  MediaSettingsMenu,
  MediaSettingsMenuItem,
  MediaPlaybackRateMenu,
  MediaRenditionMenu,
} from "media-chrome/react/menu";

import { useMediaSelector } from "media-chrome/react/media-store";

import { ChevronIcon } from "./media-player.icons";
import type { SettingsLabels } from "./media-player.types";
import type { MediaRenditionMenu as MediaRenditionMenuElement } from "media-chrome/menu";

export const SettingsMenu = ({ labels }: { labels?: SettingsLabels } = {}) => {
  const renditionMenuRef = useRef<MediaRenditionMenuElement>(null);
  const playbackRate = useMediaSelector((state) => state?.mediaPlaybackRate);
  const rendition = useMediaSelector((state) => state?.mediaRenditionSelected);
  const renditionList = useMediaSelector((state) => state?.mediaRenditionList);

  const speed = labels?.speed ?? "Speed";
  const quality = labels?.quality ?? "Quality";
  const auto = labels?.auto ?? "Auto";

  useLayoutEffect(() => {
    const el = renditionMenuRef.current;
    if (!el) return;
    // media-chrome generates the "Auto" item text internally via t("Auto") with no override prop.
    // Always set formatMenuItemText so the instance override is cleared when auto reverts to
    // its default — an early return here would leave a stale translated label on the element.
    el.formatMenuItemText = (text: string) =>
      auto !== "Auto" ? text.replace(/^Auto/, auto) : text;
  }, [auto]);

  return (
    <MediaSettingsMenu anchor="auto" hidden>
      <MediaSettingsMenuItem>
        {speed}
        <span slot="description">{playbackRate}x</span>
        <ChevronIcon slot="suffix" />
        <MediaPlaybackRateMenu slot="submenu" hidden>
          <span slot="title">{speed}</span>
          <ChevronIcon slot="back-icon" />
        </MediaPlaybackRateMenu>
      </MediaSettingsMenuItem>

      <MediaSettingsMenuItem>
        {quality}
        <span slot="description">
          {renditionList && rendition != null
            ? `${renditionList[Number(rendition)]?.height}p`
            : auto}
        </span>
        <ChevronIcon slot="suffix" />
        <MediaRenditionMenu ref={renditionMenuRef} slot="submenu" hidden>
          <span slot="title">{quality}</span>
          <ChevronIcon slot="back-icon" />
        </MediaRenditionMenu>
      </MediaSettingsMenuItem>
    </MediaSettingsMenu>
  );
};
